// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { Interesses } from "../interfaces/Interesses";

export const atualizarInteresseService = async (
  interesseId: number,
  interesseData: Partial<Interesses>
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/interesse/${interesseId}`;
    try {
      const response = await axios.post(URL, interesseData, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
